<fa-layers [fixedWidth]="true" [ngClass]="ConversationTypeClass">
   <fa-icon class="conversation-type" [icon]="ConversationType.icon"></fa-icon>
   <ng-container *ngIf="IciVisualization.length === 0">
      <fa-icon
         class="conversation-status"
         *ngFor="let iciDirection of IciDirection"
         [icon]="iciDirection.icon"
         [transform]="iciDirection.iconTransformCommand"
      ></fa-icon>
   </ng-container>
   <fa-icon
      class="ici-type"
      *ngFor="let iciVisualization of IciVisualization"
      [icon]="iciVisualization.icon"
      [transform]="iciVisualization.iconTransformCommand"
   >
   </fa-icon>
</fa-layers>
